webpackJsonp([74],{

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1267);


/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(174);

var _datetime2 = _interopRequireDefault(_datetime);

var _it = __webpack_require__(777);

var _it2 = _interopRequireDefault(_it);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('it', _it2.default);

/***/ })

},[1266]);


// WEBPACK FOOTER //
// app/datetime.it-1a486f898cca698466a7.js